import { Lock } from "lucide-react";
import { Link, useNavigate } from "react-router";
import { Button } from "@/components/ui/button";

export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <section className="mx-auto mt-16 flex max-w-md flex-col items-center gap-4 text-center">
      <Lock aria-hidden className="size-10 text-muted-foreground" />
      <h1 className="text-2xl font-semibold">You don't have permission to see this page</h1>
      <p className="text-muted-foreground">Ask an ATS admin if you need access.</p>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button asChild>
          <Link to="/">Home</Link>
        </Button>
      </div>
    </section>
  );
}
